import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { addListItem, changeListItemAnswers, sortPartRequest } from "../../../../../../actions/course-author/common";
import { ListItemsExercisePartComponent } from "./ListItemsExercisePart.component";
import { IDispatchProps } from "./types";

const mapDispatchToProps = (dispatch: Dispatch): IDispatchProps =>
  bindActionCreators({ addListItem, changeListItemAnswers, sortPartRequest }, dispatch);

export const ListItemsExercisePart = connect(null, mapDispatchToProps)(ListItemsExercisePartComponent);
